module.exports = __webpack_public_path__ + "img/popup_download_applestore.167a2416.png";